<template class="full-height">
  <div class="notice-com-container" style="height: 100%; position: relative">
    <electronic-scroll
      :content="demoContent"
      v-if="doShowElectronicScrollInner"
    ></electronic-scroll>

    <dialog-wakeUp :content="demoContent" :dialogVisible="showDialogInner"></dialog-wakeUp>

    <el-dialog
      @closed="saveAllNoticeType"
      @opened="getAgencyNoticeType"
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      title="通知類別維護"
      :visible.sync="dialogNoticeTypeVisible"
      width="50%"
    >
      <el-alert title="通知類別維護描述不得超過200字。" :closable="false" type="warning">
      </el-alert>

      <el-form :inline="true">
        <el-form-item>
          <el-button
            style="cursor: pointer"
            :loading="listLoading"
            type="success"
            icon="el-icon-refresh-left"
            circle
            @click="getAgencyNoticeType"
          ></el-button>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            circle
            @click="addNoticeType"
          ></el-button>
        </el-form-item>
      </el-form>

      <div>
        <el-table
          v-loading="listLoading"
          size="mini"
          :data="noticeTypeOpitons"
          border
          fit
          highlight-current-row
          height="500px"
        >
          <el-table-column align="center" label="項次" width="60">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="通知類別描述" width="300">
            <template slot-scope="scope">
              <el-input
                :disabled="currentNoticeTypeIndex != scope.$index"
                v-model="scope.row.val"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column align="center" label="編輯" width="140">
            <template slot-scope="scope">
              <el-button
                size="mini"
                :type="currentNoticeTypeIndex != scope.$index ? 'success' : 'primary'"
                @click="
                  currentNoticeTypeIndex != scope.$index
                    ? editNoticeType(scope.row, scope.$index)
                    : saveNoticeType(scope.row, scope.$index, true)
                "
                :icon="
                  currentNoticeTypeIndex != scope.$index ? 'el-icon-edit-outline' : 'el-icon-check'
                "
                >{{ currentNoticeTypeIndex != scope.$index ? '編輯' : '儲存' }}</el-button
              >
            </template>
          </el-table-column>

          <el-table-column align="center" label="刪除" width="100">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="deleteNoticeType(scope.row, scope.$index)"
                type="danger"
                icon="el-icon-delete"
                >刪除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      append-to-body
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="`${funcName} 維護 ${agencyMode ? '旅行社通知' : '成員通知'}`"
      :visible.sync="dialogNoticeVisible"
      width="50%"
      @closed="commonShowEdit = true"
    >
      <el-card class="box-card">
        <el-alert
          title="預設日期為兩日，系統定期清除【通知建立日期】30日前的通知。故只允許選擇30日內的日期區間。"
          :closable="false"
          type="warning"
        >
        </el-alert>
        <el-form ref="form" :model="form" :label-width="formLabelWidth">
          <el-form-item :label="funcName + '建立日期'">
            <el-tag size="mini" v-if="form.buildDate">{{ form.buildDate }}</el-tag>
          </el-form-item>

          <el-form-item
            :label="funcName + '旅行社'"
            v-if="agencyMode"
            prop="agencyCode"
            :rules="[
              {
                message: '請選擇旅行社',
                trigger: 'change',
                required: agencyMode,
              },
            ]"
          >
            <el-select
              style="width: 100%"
              filterable
              multiple
              placeholder="請選擇旅行社"
              v-model="form.agencyCode"
              value-key="key"
            >
              <el-option
                v-for="item in agencyOptions"
                :key="item.key"
                :label="item.val"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            :label="funcName + '日期'"
            prop="applyDates"
            :rules="[
              {
                required: true,
                message: '請選擇通知日期',
                trigger: 'change',
              },
            ]"
          >
            <el-date-picker
              :picker-options="pickerOptions"
              style="width: 100%"
              v-model="form.applyDates"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              range-separator="至"
              start-placeholder="開始日期"
              end-placeholder="結束日期"
              :default-time="['00:00:00']"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item
            :label="funcName + '類別'"
            prop="noticeType"
            :rules="[{ required: true, message: '請選擇類別', trigger: 'change' }]"
          >
            <el-select
              @change="getNoticyCommons"
              v-model="form.noticeType"
              filterable
              placeholder="請選擇類別"
            >
              <el-option
                v-for="item in noticeTypeOpitons"
                :key="item.key"
                :label="item.val"
                :value="item.key"
              >
              </el-option>
            </el-select>

            <el-button type="info" size="mini" style="margin-left: 5px" @click="showNoticeType"
              >維護</el-button
            >
          </el-form-item>

          <el-form-item
            :label="funcName + '型式'"
            prop="noticeStyle"
            :rules="[{ required: true, message: '請選擇型式', trigger: 'change' }]"
          >
            <el-select v-model="form.noticeStyle" filterable placeholder="請選擇型式">
              <el-option
                v-for="item in noticeStyleOptions"
                :key="item.key"
                :label="item.val"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            v-show="!agencyMode"
            :label="funcName + '人員'"
            prop="members"
            :rules="[
              {
                required: agencyMode ? false : true,
                message: '請選擇通知人員',
                trigger: 'change',
              },
            ]"
          >
            <el-select
              :disabled="form.checkedAllMembers"
              style="width: 80%"
              multiple
              v-model="form.members"
              filterable
              placeholder="請選擇型式"
            >
              <el-option
                v-for="item in roleList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>

            <el-checkbox
              style="margin-left: 10px"
              @change="triggerSelectedMembers"
              v-model="form.checkedAllMembers"
              >全選</el-checkbox
            >
          </el-form-item>

          <el-form-item :label="funcName + '常用句'">
            <el-button type="success" @click="getCommon(true)" icon="el-icon-star-off"
              >常用句選擇</el-button
            >
          </el-form-item>

          <el-form-item
            :label="funcName + '內容'"
            prop="content"
            :rules="[
              {
                required: true,
                message: '請輸入通知訊息內容',
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              v-model="form.content"
              type="textarea"
              :rows="10"
              placeholder="請輸入通知訊息內容"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveData">確 定</el-button>
        <el-button type="danger" @click="dialogNoticeVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      append-to-body
      @opened="refreshNoticeList()"
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="`${funcName} 維護 ${agencyMode ? '旅行社通知' : '成員通知'}`"
      :visible.sync="dialogVisible"
      width="80%"
      @closed="commonShowEdit = true"
    >
      <el-tabs type="border-card" v-model="editableTabsValue">
        <el-tab-pane label="通知列表" name="noticeList">
          <div>
            <el-form :inline="true">
              <el-form-item>
                <el-button
                  style="cursor: pointer"
                  :loading="listLoading"
                  type="success"
                  icon="el-icon-plus"
                  @click="addNotice"
                  >新增</el-button
                >
              </el-form-item>

              <el-form-item>
                <el-button
                  style="cursor: pointer"
                  :loading="listLoading"
                  type="success"
                  icon="el-icon-refresh-left"
                  circle
                  @click="refreshNoticeList()"
                ></el-button>
              </el-form-item>
            </el-form>

            <el-table
              v-loading="listLoading"
              size="mini"
              :data="noticeList"
              border
              fit
              highlight-current-row
              height="500px"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="通知ID" width="60">
                <template slot-scope="scope">
                  <el-tag>{{ scope.row.id }}</el-tag>
                </template>
              </el-table-column>

              <el-table-column align="center" label="通知類別" width="150">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.noticeType | notifyTypeStyleFilter">{{
                    notifyTypeDescFilter(scope.row.noticeType)
                  }}</el-tag>
                </template>
              </el-table-column>

              <el-table-column align="center" label="通知型式" width="100">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.noticeStyle | notifyTypeStyleFilter">{{
                    scope.row.noticeStyle | notifyStyleDescFilter
                  }}</el-tag>
                </template>
              </el-table-column>

              <el-table-column align="left" label="通知內容" width="360">
                <template slot-scope="scope">
                  <span>{{ scope.row.content | notifyContentFilter }}</span>
                </template>
              </el-table-column>

              <el-table-column align="left" label="通知對象" width="180">
                <template slot-scope="scope">
                  <span v-html="notifyMembersFilter(scope.row)"></span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="通知模式" width="100">
                <template slot-scope="scope">
                  <el-tag size="mini" :type="scope.row.agencyMode ? 'info' : 'success'">{{
                    scope.row.agencyMode ? '旅行社通知' : '成員通知'
                  }}</el-tag>
                </template>
              </el-table-column>

              <el-table-column align="center" label="編輯" width="140">
                <template slot-scope="scope">
                  <el-button
                    icon="el-icon-edit-outline"
                    size="mini"
                    type="primary"
                    @click="editNotice(scope.row)"
                    >編輯</el-button
                  >
                </template>
              </el-table-column>

              <el-table-column align="center" label="選擇" width="100" v-if="!commonShowEdit">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="selectedCommon(scope.row)"
                    type="warning"
                    icon="el-icon-check"
                    >選擇</el-button
                  >
                </template>
              </el-table-column>

              <el-table-column align="center" label="刪除" width="100">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="deleteAgencyNotice(scope.row)"
                    type="danger"
                    icon="el-icon-delete"
                    >刪除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>

          <pagination
            v-show="noticeTotal > 0"
            style="padding-top: 0"
            layout="prev, pager, next"
            :total="noticeTotal"
            :page.sync="listNoticeQuery.page"
            :limit.sync="listNoticeQuery.limit"
            @pagination="getAgencyNotice(false)"
          />
        </el-tab-pane>
      </el-tabs>

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="dialogVisible = false">關 閉</el-button>
      </span>
    </el-dialog>

    <el-dialog
      @closed="saveAllCommon"
      append-to-body
      v-loading="dialogCommonLoading"
      :top="dialogTopMargin"
      :title="funcName + '常用句維護'"
      :visible.sync="commonDialogVisible"
      width="60%"
    >
      <div>
        <el-alert title="常用句不得超過500字。" :closable="false" type="warning"> </el-alert>

        <el-form :inline="true">
          <el-form-item>
            <el-button
              style="cursor: pointer"
              :loading="listLoading"
              type="success"
              icon="el-icon-refresh-left"
              circle
              @click="getCommon(false)"
            ></el-button>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              circle
              @click="addCommon"
            ></el-button>
          </el-form-item>
        </el-form>

        <el-table
          v-loading="listLoading"
          size="mini"
          :data="commonList"
          border
          fit
          highlight-current-row
          height="500px"
        >
          <el-table-column align="center" label="項次" width="60">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="通知類別" width="160">
            <template slot-scope="scope">
              <el-select
                v-if="noticeTypeOpitons && noticeTypeOpitons.length > 0"
                :disabled="currentCommonIndex != scope.$index"
                v-model="scope.row.commonType"
                filterable
                placeholder="請選擇類別"
              >
                <el-option
                  v-for="item in noticeTypeOpitons"
                  :key="item.key"
                  :label="item.val"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column align="center" label="常用句" width="250">
            <template slot-scope="scope">
              <el-input
                maxlength="500"
                type="textarea"
                :rows="2"
                :disabled="currentCommonIndex != scope.$index"
                v-model="scope.row.common"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column align="center" label="建立日期" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.buildDate }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="建立者" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.buildUserName }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="編輯" width="100">
            <template slot-scope="scope">
              <el-button
                size="mini"
                :type="currentCommonIndex != scope.$index ? 'success' : 'primary'"
                @click="
                  currentCommonIndex != scope.$index
                    ? editCommon(scope.row, scope.$index)
                    : saveCommon(scope.row, scope.$index, true)
                "
                :icon="
                  currentCommonIndex != scope.$index ? 'el-icon-edit-outline' : 'el-icon-check'
                "
                >{{ currentCommonIndex != scope.$index ? '編輯' : '儲存' }}</el-button
              >
            </template>
          </el-table-column>

          <el-table-column align="center" label="選擇" width="100" v-if="!commonShowEdit">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="selectedCommon(scope.row)"
                type="warning"
                icon="el-icon-check"
                >選擇</el-button
              >
            </template>
          </el-table-column>

          <el-table-column align="center" label="刪除" width="100">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="deleteAgencyNoticeCommon(scope.row, scope.$index)"
                type="danger"
                icon="el-icon-delete"
                >刪除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 系統通知 -->
    <el-dialog
      @closed="sysNoticeDialogVisible = false"
      append-to-body
      v-loading="dialogSysNoticeLoading"
      :top="dialogTopMargin"
      title="系統通知維護"
      :visible.sync="sysNoticeDialogVisible"
      width="80%"
    >
      <div>
        <el-alert title="通知內容不得超過500字。" :closable="false" type="warning"> </el-alert>

        <el-form :inline="true">
          <el-form-item>
            <el-button
              style="cursor: pointer"
              :loading="listLoading"
              type="success"
              icon="el-icon-refresh-left"
              circle
              @click="getSysNotice"
            ></el-button>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              circle
              @click="addSysNotice"
            ></el-button>
          </el-form-item>
        </el-form>

        <el-table
          v-loading="listLoading"
          size="mini"
          :data="sysNoticeList"
          border
          fit
          highlight-current-row
          height="500px"
        >
          <el-table-column align="center" label="項次" width="60">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="內容" width="250">
            <template slot-scope="scope">
              <el-input
                maxlength="500"
                type="textarea"
                :rows="3"
                :disabled="currentSysNoticeIndex != scope.$index"
                v-model="scope.row.content"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column align="center" label="建立日期" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.buildDate }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="起始日期" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.applyDates[0] }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="結束日期" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.applyDates[1] }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="建立者" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.buildUser }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="編輯" width="100">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="editSysNotice(scope.row)"
                type="primary"
                icon="el-icon-edit-outline"
                >編輯</el-button
              >
            </template>
          </el-table-column>

          <el-table-column align="center" label="刪除" width="100">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="deleteSysNotice(scope.row)"
                type="danger"
                icon="el-icon-delete"
                >刪除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="sysNoticeTotal > 0"
          style="padding-top: 0"
          layout="prev, pager, next"
          :total="sysNoticeTotal"
          :page.sync="listSysNoticeQuery.page"
          :limit.sync="listSysNoticeQuery.limit"
          @pagination="getSysNotice"
        />
      </div>
    </el-dialog>

    <!-- 系統通知表單 -->
    <el-dialog
      append-to-body
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      title="系統維護通知"
      :visible.sync="dialogSysNoticeFormVisible"
      width="50%"
      @closed="dialogSysNoticeFormVisible = false"
    >
      <el-card class="box-card">
        <el-alert
          title="預設日期為兩日，系統定期清除【通知建立日期】30日前的通知。故只允許選擇30日內的日期區間。"
          :closable="false"
          type="warning"
        >
        </el-alert>
        <el-form ref="sysNoticeForm" :model="form" :label-width="formLabelWidth">
          <el-form-item :label="'建立日期'">
            <el-tag size="mini" v-if="form.buildDate">{{ form.buildDate }}</el-tag>
          </el-form-item>

          <el-form-item
            :label="'日期'"
            prop="applyDates"
            :rules="[
              {
                required: true,
                message: '請選擇通知日期',
                trigger: 'change',
              },
            ]"
          >
            <el-date-picker
              :picker-options="pickerOptions"
              style="width: 100%"
              v-model="form.applyDates"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              range-separator="至"
              start-placeholder="開始日期"
              end-placeholder="結束日期"
              :default-time="['00:00:00']"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item
            :label="'內容'"
            prop="content"
            :rules="[
              {
                required: true,
                message: '請輸入通知訊息內容',
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              v-model="form.content"
              type="textarea"
              :rows="10"
              placeholder="請輸入通知訊息內容"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveSysNotice">確 定</el-button>
        <el-button type="danger" @click="dialogSysNoticeFormVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <div style="padding: 20px; padding-bottom: 0">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item label="旅行社名稱查詢">
          <el-input
            v-model="listQuery.qry"
            placeholder="輸入旅行社名稱"
            @keyup.enter.native="getList"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getList">查詢</el-button>
        </el-form-item>

        <el-form-item>
          <el-button
            v-if="multipleSelection.length > 0"
            type="danger"
            @click="addNoticeHandle(true)"
            icon="el-icon-bell"
            >旅行社通知</el-button
          >
        </el-form-item>

        <el-form-item>
          <el-button type="info" @click="agencyNoticeHistory" icon="el-icon-info"
            >旅行社通知維護</el-button
          >
        </el-form-item>

        <el-form-item>
          <el-button type="success" @click="getCommon(false)" icon="el-icon-star-off"
            >常用句維護</el-button
          >
        </el-form-item>

        <el-form-item>
          <el-button type="success" @click="getSysNotice" icon="el-icon-star-off"
            >系統通知維護</el-button
          >
        </el-form-item>

        <el-form-item>
          <el-button
            style="cursor: pointer"
            :loading="listLoading"
            type="success"
            icon="el-icon-refresh-left"
            circle
            @click="refresh()"
          ></el-button>
        </el-form-item>

        <el-form-item
          label="通知樣式預覽"
          style="border: 1px solid #ccc; padding: 5px; border-radius: 10px"
        >
          <el-radio-group v-model="demo" @change="showDemo">
            <el-radio :label="item.key" v-for="item in noticeStyleOptions" :key="item.key">{{
              item.val
            }}</el-radio>
          </el-radio-group>

          <el-button size="mini" type="danger" style="margin-left: 15px" @click="closeDemo"
            >關閉預覽</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div style="position: relative; height: 80%">
      <el-table
        @selection-change="handleSelectionChange"
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        height="100%"
      >
        <el-table-column align="center" type="selection" width="55"> </el-table-column>

        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="旅行社代碼" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.agencyCode }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="旅行社名稱" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.agencyName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="統編" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.vatNumber }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="成員通知" width="180">
          <template slot-scope="scope">
            <el-button type="warning" @click="membersNotice(scope.row)" icon="el-icon-bell"
              >成員通知</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total > 0"
      style="padding-top: 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import ElectronicScroll from '@/views/ita/components/electronicScrollComponents.vue'
import DialogWakeUp from '@/views/ita/components/dialogComponents.vue'

import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { MessageBox, Message } from 'element-ui'
import { getTaiwanCurrentTime, dateTo10CharString, addDays } from '@/utils/funcs'
import { saveViewPoint } from '@/api/travel'
import {
  getAgencyList,
  getAgencyNoticeStyleType,
  getAgencyNoticeType,
  saveAgencyNoticeCommon,
  getAgencyNoticeCommon,
  deleteAgencyNoticeCommon,
  saveAgencyNotice,
  getAgencyRoles,
  getAgencyNotice,
  deleteAgencyNotice,
  saveAgencyNoticeType,
  deleteAgencyNoticeType,
  getAgencyOptions,
} from '@/api/agency'
import { mapGetters } from 'vuex'
import { getSysNotice, saveSysNotice, deleteSysNotice } from '@/api/system'

var defaultNotice = {
  applyDates: [],
  members: [],
  noticeStyle: null,
  noticeType: null,
  content: null,
  checkedAllMembers: false,
  buildDate: null,
  agencyOptions: [],
  agencyCode: [],
  // buildDate: getTaiwanCurrentTime(),
}

var defaultSysNotice = {
  applyDates: [],
  content: null,
  buildDate: null,
}

export default {
  name: 'NoticeCcomponents',
  components: {
    Pagination,
    ElectronicScroll,
    DialogWakeUp,
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  filters: {
    memberInfo(m) {
      return `${m.name} (${m.roleDesc.join()})`
    },
    cuttingText(text) {
      return text ? (text.length > 15 ? `${text.substring(0, 20)}...` : text) : ''
    },
    notifyTypeStyleFilter(v) {
      const descMap = {
        1: 'success',
      }
      return descMap[v]
    },
    notifyStyleStyleFilter(v) {
      const descMap = {
        1: 'success',
        2: 'info',
        3: 'danger',
        4: 'warning',
      }
      return descMap[v]
    },

    notifyStyleDescFilter(v) {
      const descMap = {
        1: '跑馬燈',
        2: '彈跳視窗',
        3: '消息通知',
        4: 'Email通知',
      }
      return descMap[v]
    },
    notifyContentFilter(v) {
      if (!v) {
        return v
      }
      return v.length > 50 ? `${v.substring(0, 50)}...` : v
    },
  },
  watch: {
    showNoticeInner: {
      deep: false,
      handler(val) {
        if (!val) {
          this.$notify.closeAll()
        }
      },
    },
    multipleSelection: {
      deep: false,
      handler(val) {
        if (val.length > 0) {
          this.agencyMode = true
        } else {
          this.agencyMode = false
        }
      },
    },
  },
  data() {
    return {
      demoContent: '測試通知',
      doShowElectronicScrollInner: false,
      showDialogInner: true,
      showNoticeInner: false,
      demo: null,
      agencyOptions: [],
      currentNoticeTypeIndex: null,
      dialogNoticeTypeVisible: false,
      dialogNoticeVisible: false,
      noticeList: [],
      editableTabsValue: 'noticeList',
      currentAgencyRow: null,
      roleList: [],
      agencyMode: false,
      commonShowEdit: true,
      defaultDate: [],
      commonSelected: null,
      currentCommonIndex: null,
      commonList: [],
      dialogCommonLoading: false,
      commonDialogVisible: false,
      noticeStyleOptions: [],
      noticeTypeOpitons: [],
      agencyMembers: [],
      funcName: '通知',
      dialogTopMargin: '2%',
      formLabelWidth: '120px',
      form: {},
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      },
      listNoticeQuery: {
        agencyCode: '',
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
        agencyMode: false,
      },
      listSysNoticeQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      },
      total: 0,
      noticeTotal: 0,
      list: [],
      multipleSelection: [],
      pickerOptions: {
        disabledDate: time => {
          const day1 = 1 * 24 * 3600 * 1000
          const day29 = 29 * 24 * 3600 * 1000
          // let minTime = new Date(this.form.applyDates[0]).getTime();
          // let maxTime = new Date(this.form.applyDates[1]).getTime();
          let minTime = new Date().getTime()
          let maxTime = new Date().getTime() + day29
          return !(time.getTime() >= minTime - day1 && time.getTime() <= maxTime)
        },
      },

      sysNoticeDialogVisible: false,
      sysNoticeList: [],
      currentSysNoticeIndex: null,
      dialogSysNoticeLoading: false,
      dialogSysNoticeFormVisible: false,
      sysNoticeTotal: 0,
    }
  },
  async created() {
    this.listLoading = true
    this.form = defaultNotice
    this.defaultDates()
    await this.getAgencyOptions()
    await this.getAgencyRoles()
    await this.getAgencyNoticeType()
    await this.getAgencyNoticeStyleType()
    await this.getList()
  },
  methods: {
    closeDemo() {
      let vm = this
      vm.doShowElectronicScrollInner = false
      vm.showDialogInner = false
      vm.demoContent = ''
      vm.showNoticeInner = false
    },
    showDemo() {
      let vm = this
      switch (vm.demo) {
        case 1:
          vm.doShowElectronicScrollInner = true
          vm.showDialogInner = false
          this.$store.dispatch('app/showDialog', false)
          this.$notify.closeAll()
          vm.demoContent = `跑馬燈通知Demo`
          break
        case 2:
          vm.doShowElectronicScrollInner = false
          vm.showDialogInner = true
          this.$store.dispatch('app/showDialog', false)
          this.$notify.closeAll()
          vm.demoContent = `彈跳視窗通知Demo`
          this.$store.dispatch('app/showDialog', true)

          break
        case 3:
          vm.doShowElectronicScrollInner = false
          vm.showDialogInner = false
          vm.showNoticeInner = true
          const h = this.$createElement
          vm.demoContent = `消息通知通知Demo`
          this.$notify({
            title: '系統通知',
            message: h('i', { style: 'color: teal' }, `${vm.demoContent}`),
            duration: 10000,
          })
          break
        default:
          break
      }
    },
    async getAgencyOptions() {
      let resp = await getAgencyOptions()
      this.agencyOptions = resp.data
    },
    async agencyNoticeHistory() {
      this.agencyMode = true
      this.dialogVisible = true
    },
    async getNoticyCommons() {
      let vm = this
      let type = vm.form.noticeType

      let resp = await getAgencyNoticeCommon()
      vm.commonList = resp.data

      let commons = vm.commonList.filter(m => {
        return m.commonType == type
      })

      if (commons.length > 0) {
        vm.commonList = commons
        vm.commonShowEdit = false
        vm.commonDialogVisible = true
      }
    },
    notifyTypeDescFilter(v) {
      let r = this.noticeTypeOpitons.filter(f => {
        return f.key == v
      })

      let val = ''
      if (r && r.length > 0) {
        val = r[0].val
        debugger
      }
      return val
    },
    // notifyTypeDescFilter(v) {
    //   return this.noticeTypeOpitons.filter((f) => {
    //     return f.key == v;
    //   })[0].val;
    // },
    async addNoticeType() {
      let newType = {
        key: null,
        val: null,
      }
      this.noticeTypeOpitons.push(newType)
      this.currentNoticeTypeIndex = this.noticeTypeOpitons.length - 1
    },
    async editNoticeType(row, index) {
      if (this.currentNoticeTypeIndex != null && this.currentNoticeTypeIndex != index) {
        let payload = this.noticeTypeOpitons[this.currentNoticeTypeIndex]
        try {
          await this.saveNoticeType(payload, this.currentNoticeTypeIndex, true)
        } catch (error) {
          console.log(error)
        }
      }
      this.currentNoticeTypeIndex = index
    },
    async saveNoticeType(row, index, showMsgBox) {
      if (!row.val) {
        alert(`第${index + 1}筆未輸入類別儲存內容`)
        return
      }
      this.currentNoticeTypeIndex = null
      let payload = { id: row.key, desc: row.val }
      let resp = await saveAgencyNoticeType(payload)
      row.key = resp.data
      // await this.getAgencyNoticeType();

      if (showMsgBox) {
        Message({
          message: `第【${index + 1}】筆類別儲存完成`,
          type: 'success',
          duration: 3 * 1000,
        })
      }
    },
    async saveAllNoticeType() {
      let vm = this
      vm.noticeTypeOpitons.forEach(async (f, index) => {
        if (f.val) {
          await vm.saveNoticeType(f, index, false)
        }
      })
    },
    showNoticeType() {
      this.dialogNoticeTypeVisible = true
    },

    async getAgencyNoticeType() {
      let resp = await getAgencyNoticeType()
      this.noticeTypeOpitons = resp.data
    },
    async deleteNoticeType(row, index) {
      alert(`刪除通知類別會一併刪除相關的常用句!`)
      if (!confirm(`確定刪除此筆通知類別?`)) {
        return
      }

      let processSuccess = true
      if (row.key) {
        try {
          this.listLoading = true
          let resp = await deleteAgencyNoticeType({ id: row.key })
        } catch (error) {
          console.log(error)
          processSuccess = false
        } finally {
          this.listLoading = false
        }
      }

      if (!processSuccess) {
        return
      }

      this.noticeTypeOpitons.splice(index, 1)

      Message({
        message: `第【${index + 1}】筆通知類別刪除完成`,
        type: 'success',
        duration: 3 * 1000,
      })
    },
    notifyMembersFilter(v) {
      let vm = this
      let members = v.members
      let r = []

      if (this.agencyMode) {
        let ags = []
        members.forEach(f => {
          let ag = vm.agencyOptions.filter(a => {
            return a.key == f
          })

          if (ag && ag.length > 0) {
            ags.push(ag[0].val)
          }
        })
        r = ags
      } else {
        const descMap = {
          'ITA-TRAVEL-AGENCY': '旅行社-管理角色',
          // "AGENCY-NORMAL": "旅行社-一般權限帳號",
          // "AGENCY-SENIOR": "旅行社-高階主管",
          // "AGENCY-FINANCIAL": "旅行社-財務會計",
          'AGENCY-NORMAL': '旅行社-OP',
          'AGENCY-SENIOR': '旅行社-線控',
          'AGENCY-FINANCIAL': '旅行社-會計',
        }

        if (members && members.length > 0) {
          members.forEach(element => {
            if (descMap[element]) {
              r.push(descMap[element])
            }
          })
        }
      }

      return r && r.length > 0 ? r.join('<br />') : []
    },
    async refresh() {
      this.listQuery = {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      }
      await this.getList()
    },
    async refreshNoticeList() {
      this.listNoticeQuery.agencyCode = this.agencyMode ? '' : this.currentAgencyRow.agencyCode
      this.listNoticeQuery.qry = ''
      this.listNoticeQuery.date = ''
      this.listNoticeQuery.status = null
      this.listNoticeQuery.page = 1
      this.listNoticeQuery.limit = 20
      this.listNoticeQuery.sort = '-id'
      this.listNoticeQuery.agencyMode = this.agencyMode
      await this.getAgencyNotice(this.agencyMode)
    },
    async deleteAgencyNotice(row) {
      if (!confirm(`確定要刪除通知`)) {
        return
      }
      try {
        this.listLoading = true
        let resp = await deleteAgencyNotice({ id: row.id })
        Message({
          message: `通知刪除完成`,
          type: 'success',
          duration: 3 * 1000,
        })
        await this.refreshNoticeList()
      } catch (error) {
        console.log(error)
      } finally {
        this.listLoading = false
      }
    },
    async addNoticeHandle(agencyMode) {
      this.agencyMode = agencyMode
      await this.addNotice()
    },
    async addNotice() {
      this.form = JSON.parse(JSON.stringify(defaultSysNotice))
      this.form.applyDates = JSON.parse(JSON.stringify(this.defaultDate))
      this.dialogNoticeVisible = true
    },
    async editNotice(row) {
      this.form = row
      this.dialogNoticeVisible = true
    },
    async getAgencyNotice(agencyMode) {
      try {
        this.agencyMode = agencyMode
        this.listNoticeQuery.agencyCode = agencyMode ? '' : this.currentAgencyRow.agencyCode
        this.listNoticeQuery.agencyMode = agencyMode
        this.listLoading = true
        this.noticeList = []
        let resp = await getAgencyNotice(this.listNoticeQuery)
        this.noticeList = resp.data.data

        this.noticeTotal = resp.data.total
      } catch (error) {
        console.log(error)
      } finally {
        this.listLoading = false
      }
    },
    async getAgencyRoles() {
      let resp = await getAgencyRoles()
      this.roleList = resp.data
    },
    async deleteAgencyNoticeCommon(row, index) {
      if (!confirm(`確定刪除此筆常用句?`)) {
        return
      }

      let processSuccess = true
      if (row.id) {
        try {
          this.listLoading = true
          let resp = await deleteAgencyNoticeCommon({ id: row.id })
        } catch (error) {
          console.log(error)
          processSuccess = false
        } finally {
          this.listLoading = false
        }
      }

      if (!processSuccess) {
        return
      }

      this.commonList.splice(index, 1)

      Message({
        message: `第【${index + 1}】筆常用句刪除完成`,
        type: 'success',
        duration: 3 * 1000,
      })
    },
    async selectedCommon(row) {
      if (row.common) {
        this.form.content = row.common

        // if (!this.form.content) {
        //   this.form.content = row.common;
        // } else {
        //   this.form.content += `，${row.common}`;
        // }
        this.commonDialogVisible = false
      }
    },

    async getAgencyNoticeStyleType() {
      let resp = await getAgencyNoticeStyleType()

      this.noticeStyleOptions = resp.data
    },
    async commonSelectedHandle() {
      if (this.commonSelected) {
        if (this.form.content) {
          this.form.content = this.commonSelected
        } else {
          this.form.content += `，${this.commonSelected}`
        }
      }
    },
    async editCommon(row, index) {
      if (this.currentCommonIndex != null && this.currentCommonIndex != index) {
        let payload = this.commonList[this.currentCommonIndex]
        try {
          await this.saveCommon(payload, this.currentCommonIndex, true)
        } catch (error) {
          console.log(error)
        }
      }
      this.currentCommonIndex = index
    },
    async saveAllCommon() {
      let vm = this
      vm.commonList.forEach(async (f, index) => {
        if (f.common) {
          await vm.saveCommon(f, index, false)
        }
      })
    },
    async saveCommon(row, index, showMsgBox) {
      if (!row.common) {
        alert(`未輸入常用句內容`)
        return
      }
      this.currentCommonIndex = null
      let resp = await saveAgencyNoticeCommon(row)
      row.id = resp.data
      if (showMsgBox) {
        Message({
          message: `第【${index + 1}】筆常用句儲存完成`,
          type: 'success',
          duration: 3 * 1000,
        })
      }
    },
    async addCommon() {
      let rightNow = new Date()
      let now = rightNow.toISOString().slice(0, 10)

      let newCommon = {
        id: null,
        common: null,
        buildDate: now,
        buildUserName: this.userInfo.name,
      }

      this.commonList.push(newCommon)

      this.currentCommonIndex = this.commonList.length - 1
    },
    async getCommon(fromMember) {
      let vm = this
      vm.commonShowEdit = !fromMember
      // vm.listLoading = true;

      try {
        let resp = await getAgencyNoticeCommon()
        vm.commonList = resp.data
      } catch (error) {
        console.log(error)
      } finally {
        // vm.listLoading = false;
      }
      vm.commonDialogVisible = true
    },
    async getSysNotice() {
      let vm = this
      this.listLoading = true
      try {
        let resp = await getSysNotice(this.listSysNoticeQuery)
        vm.sysNoticeList = resp.data.data
        vm.sysNoticeTotal = resp.data.total
      } catch (error) {
        console.log(error)
      } finally {
        this.listLoading = false
        //this.listLoading = false;
        // vm.listLoading = false;
      }
      vm.sysNoticeDialogVisible = true
    },
    addSysNotice() {
      this.form = JSON.parse(JSON.stringify(defaultNotice))
      this.form.applyDates = JSON.parse(JSON.stringify(this.defaultDate))
      this.dialogSysNoticeFormVisible = true
    },
    saveSysNotice() {
      let vm = this
      if (!confirm(`確定要儲存資料?`)) {
        return
      }
      this.$refs['sysNoticeForm'].validate(async valid => {
        if (valid) {
          vm.dialogLoading = true
          let payload = JSON.parse(JSON.stringify(vm.form))
          let resp = await saveSysNotice(payload)
          this.dialogSysNoticeFormVisible = false
          vm.dialogLoading = false
          await this.getSysNotice()
          Message({
            message: '資料處理完成',
            type: 'success',
            duration: 5 * 1000,
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editSysNotice(row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.dialogSysNoticeFormVisible = true
    },
    async deleteSysNotice(row) {
      if (!confirm(`確定刪除此筆通知類別?`)) {
        return
      }
      try {
        this.listLoading = true
        let resp = await deleteSysNotice({ id: row.id })
      } catch (error) {
        console.log(error)
      } finally {
        this.listLoading = false
        await this.getSysNotice()
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    triggerSelectedMembers() {
      let vm = this
      vm.form.members = []
      if (vm.form.checkedAllMembers) {
        let ids = vm.roleList.map(f => {
          return f.code
        })
        vm.form.members = ids
      }
    },
    // defaultDates() {
    //   let now = getTaiwanCurrentTime();
    //   let todayDate = dateTo10CharString(now);
    //   let today = `${todayDate}`;
    //   const day2 = 2 * 24 * 3600 * 1000;
    //   const date1 = new Date(today);
    //   const date2 = addDays(date1, 2);
    //   this.defaultDate[0] = date1;
    //   this.defaultDate[1] = date2;
    // },
    defaultDates() {
      let now = getTaiwanCurrentTime()
      let today = dateTo10CharString(now)
      const date1 = new Date(today)
      const date2 = addDays(date1, 2)
      this.defaultDate[0] = `${dateTo10CharString(date1)} 00:00`
      this.defaultDate[1] = `${dateTo10CharString(date2)} 00:00`
    },
    async membersNotice(row) {
      this.currentAgencyRow = row
      this.agencyMode = false
      this.dialogVisible = true
    },
    async saveData() {
      let vm = this
      if (!confirm(`確定要儲存【${vm.funcName}}】資料?`)) {
        return
      }

      this.$refs['form'].validate(async valid => {
        if (valid) {
          vm.dialogLoading = true
          let payload = JSON.parse(JSON.stringify(vm.form))

          if (!vm.agencyMode) {
            payload.agencyCode = [vm.currentAgencyRow.agencyCode]
          }

          payload.agencyMode = vm.agencyMode

          console.log(JSON.stringify(payload))

          let resp = await saveAgencyNotice(payload)
          this.dialogNoticeVisible = false
          vm.dialogLoading = false
          await this.refreshNoticeList()
          Message({
            message: '資料處理完成',
            type: 'success',
            duration: 5 * 1000,
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async getList() {
      if (!this.listLoading) {
        this.listLoading = true
      }
      try {
        let resp = await getAgencyList(this.listQuery)
        this.list = resp.data.data
        this.total = resp.data.total
      } catch (error) {
        console.log(error)
      } finally {
        this.listLoading = false
      }
    },
  },
}
</script>

<style scoped>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}
/deep/:disabled {
  color: blue !important;
}

/deep/.marqee {
  top: -81px;
}
</style>
